import React from 'react';
import PropTypes from 'prop-types';

// core
import { getVisitorPhotoSrc } from '_core/utils/getVisitorPhotoSrc';
import {
  getLocalVisitorAvatar,
  getLocalVisitorAvatarPreview
} from '_core/utils/localVisitorAvatar';
import { withVisitorInfo } from '_core/utils/visitorInfo';
import { Avatar } from '_core/components/Avatar';

export const RawUserAvatar = (props) => {
  const { userInfo, visitorInfo, ...rest } = props;

  const profile = userInfo != null ? userInfo : visitorInfo.info;
  const profileId = profile?.id;
  const [, forceUpdate] = React.useReducer((x) => x + 1, 0);
  const [fallbackSrc, setFallbackSrc] = React.useState(null);

  React.useEffect(() => {
    const onLocalAvatar = (event) => {
      const vid = event?.detail?.visitorId;
      if (vid && profileId && Number(vid) === Number(profileId)) {
        forceUpdate();
      }
    };

    window.addEventListener('local-visitor-avatar', onLocalAvatar);
    return () => window.removeEventListener('local-visitor-avatar', onLocalAvatar);
  }, [profileId]);

  const localAvatar =
    profile?.id && userInfo == null ? getLocalVisitorAvatar(profile.id) : null;
  const localPreview =
    profile?.id && userInfo == null ? getLocalVisitorAvatarPreview(profile.id) : null;

  const letterProps = {
    login: profile.login,
    firstname: profile.firstname,
    lastname: profile.lastname
  };

  // server src (preferred)
  const serverSrc = localAvatar?.path
    ? `${getVisitorPhotoSrc(localAvatar.path, 'md')}${
        localAvatar.id ? `?v=${encodeURIComponent(String(localAvatar.id))}` : ''
      }`
    : typeof profile.photo === 'string'
      ? getVisitorPhotoSrc(profile.photo, 'md')
      : profile.photo?.id > 0
        ? getVisitorPhotoSrc(profile.photo.path, 'md')
        : null;

  React.useEffect(() => {
    // Reset fallback on photo change so we retry loading medium.
    setFallbackSrc(null);
  }, [serverSrc]);

  const shouldUsePreviewFallback =
    !!localPreview?.dataUrl &&
    !!localAvatar?.id &&
    Number(localPreview.photoId) === Number(localAvatar.id);

  const imageProps = localAvatar?.cleared
    ? {}
    : serverSrc || fallbackSrc
      ? {
          alt: profile.login,
          src: fallbackSrc || serverSrc,
          imgProps: {
            onError: () => {
              if (fallbackSrc) return;
              if (shouldUsePreviewFallback) {
                setFallbackSrc(localPreview.dataUrl);
              }
            }
          }
        }
      : {};

  return <Avatar letterProps={letterProps} {...imageProps} {...rest} />;
};

RawUserAvatar.defaultProps = {};

RawUserAvatar.propTypes = {
  // self props
  userInfo: PropTypes.object,

  // withVisitorInfo
  visitorInfo: PropTypes.object.isRequired
};

export const UserAvatar = withVisitorInfo(RawUserAvatar);
